<template>
  <section>
    <span v-if="outlined && Seleccionada">
      <v-text-field
        outlined
        readonly
        filled
        dense
        label="Provincia"
        :value="Seleccionada.Descripcion_provincia"
        hide-details
      ></v-text-field>
    </span>
    <span v-if="Seleccionada && !outlined && !texto">{{
      Seleccionada.Descripcion_provincia
    }}</span>
    <h3 v-if="texto">Provincia: {{ Seleccionada.Descripcion_provincia }}</h3>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    id_provincia: Number,
    outlined: {
      type: Boolean,
      default: false,
    },
    texto: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      Seleccionada: undefined,
    };
  },
  computed: {
    ...mapState("provincias", ["Lista"]),
  },
  methods: {
    filtrar() {
      this.Seleccionada = this.Lista.find(
        (x) => x.id_provincia === this.id_provincia
      );
    },
  },
  async mounted() {
    this.filtrar();
  },
  watch: {
    id_provincia() {
      this.filtrar();
    },
  },
};
</script>
